import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr; /* ✅ 한 줄 = 1개 */
  gap: 12px; /* 카드 사이 간격만 */
`;
